export const TitleBar = {
    title: "Danh sách yêu cầu vật tư",
    addButtonText: "Tạo phiếu yêu cầu vật tư",
};

export const Search = {
    searchText: "Tìm kiếm theo từ khoá Mã yêu cầu",
};

export const Filter = {
    filterText: "Bộ lọc",
    filterTitle: "Lựa chọn và áp dụng bộ lọc để hiển thị thông tin tìm kiếm",
};

export const Sort = {
    sortText: "Sắp xếp:",
    sortButtonText: "Ngày đến hạn gần nhất",
};

export interface ColumnAttribute {
    text: string;
    icon: any;
}

export const TableColumns = [
    { text: "Mã yêu cầu", icon: <></> },
    { text: "Mã đơn hàng", icon: <></> },
    { text: "Ngày tạo", icon: <></> },
    { text: "Ngày đến hạn", icon: <></> },
    { text: "Trạng thái", icon: <></> },
    // { text: "Phụ trách", icon: <></> },
];

export const ExportRequestMaterialTableColumn = [
    { text: 'Mã vật tư', icon: <></> },
    { text: 'Tên vật tư', icon: <></> },
    { text: 'Số lượng yêu cầu', icon: <></> },
    { text: 'Số lượng đã xuất', icon: <></> },
    { text: 'Số lượng muốn xuất', icon: <></> },
    { text: 'Ngày xuất kho', icon: <></> },
    { text: '', icon: <></> },
];

export const PaginationBarConfig = {
    text: "Hiển thị",
    page: "Trong",
};

export const MaterialRequestMaterialTableColumns = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "", icon: <></> },
];

export const MaterialRequestAddMaterialTableColumns = [
    { text: "Mã vật tư", icon: <></> },
    { text: "Tên vật tư", icon: <></> },
    { text: "Tồn kho", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "", icon: <></> },
];

export const WarningCancelMaterialRequest = {
    title: "Huỷ phiếu yêu cầu",
    context: [
        "Huỷ phiếu yêu cầu sẽ tạm dừng tất cả các hoạt động liên quan, bạn có chắc muốn huỷ bỏ không? " +
            "Hành động này sẽ không được hoàn tác.",
    ],
    reason: "Lý do hủy phiếu yêu cầu",
};

export const WarningDiscardMaterialRequest = {
    title: "Huỷ tạo phiếu yêu cầu",
    context:
        "Thông tin bạn đã cung cấp sẽ không được lưu, bạn có chắc chắn " +
        "muốn huỷ bỏ không? Hành động này sẽ không được hoàn tác.",
};

export const WarningDeclineMaterialRequest = {
    title: "Từ chối duyệt phiếu lãnh",
    context: ["Bạn có chắc chắn muốn từ chối duyệt phiếu lãnh này không? Hành động này sẽ không được hoàn tác"],
    reason: "Lý do từ chối",
};

export const WarningDeclineReasonMaterialRequest = {
    title: "Lý do phiếu lãnh vật tư bị từ chối",
};
